import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaAcceptedOffersConsors } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    subscriptionIdentifier: string;
};

export const schemaLoanRequestResolver_GetConsorsOfferStatus = schemaAcceptedOffersConsors
    .pick({
        acceptanceStatus: true,
        failureReason: true,
    })
    .nullable();

export type SchemaLoanRequestResolver_GetConsorsOfferStatus = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsOfferStatus
>;

export type LoanRequestResolver_GetConsorsOfferStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsOfferStatus
>;
